export default __webpack_public_path__ + "static/xaml-037c196712215e4eff3c7acc2f593eb2.svg";